import { APP_BASE_HREF } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ResponseHandler } from '@app/_core/helper/ResponseHandler';
import { Utils } from '@app/_core/helper/Utils';
import { AppService } from '@app/_core/services/app.service';
import { AuditorService } from '@app/_core/services/auditor.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { FilteredAuditsList } from '@app/_entities/filtered-list';
import { FilterDialogComponent } from '@app/pages/common/filter-dialog/filter-dialog.component';
import { ShowHideDialogComponent } from '@app/pages/common/show-hide-dialog/show-hide-dialog.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { TableLazyLoadEvent } from 'primeng/table';
import { catchError, EMPTY, map } from 'rxjs';

import { InteractionDetailsComponent } from '../interactions/interaction-details/interaction-details.component';
import { SecurityService } from './../../../_core/services/security.service';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-audits',
  templateUrl: './audits.component.html',
  styleUrls: ['./audits.component.scss'],
})
export class AuditsComponent implements OnInit, OnDestroy {
  isAIAudits: any;
  loadAuditsTimeout: any;
  constructor(
    private utils: Utils,
    private cdr: ChangeDetectorRef,
    private appService: AppService,
    private auditorService: AuditorService,
    private securityService: SecurityService,
    private webStorage: WebStorageService,
    private router: Router,
    private modalService: BsModalService,
    @Inject(APP_BASE_HREF) public baseHref: string
  ) { }

  currentMenu: any = {};
  action = '';
  innerHeight = 10;
  //showTable: boolean = true;
  // showCrud: boolean = false;

  totalRecords: number;
  loading: boolean;
  modalRef?: BsModalRef;
  showDateRange: boolean = true;
  first = 0;
  auditList: any = [];
  localStorageName = 'AuditsColumnDisplaySettings';
  headercount: any = { shown: 0, hidden: 0 };

  /*globalfilter*/
  findOptions: any = [
    // { value: 'Agent', label: 'Agent' },
    // { value: 'Group', label: 'Group' },
    // { value: 'Manager', label: 'Manager' },
    // { value: 'Auditor', label: 'Auditor' },
    // { value: 'Status', label: 'Status' },
    // { value: 'SurveyForm', label: 'Survey Form' },
    { value: 'FirstName', label: 'Agent First Name' },
    { value: 'LastName', label: 'Agent Last Name' },
    { value: 'SurveyID', label: 'SurveyID' },
    { value: 'InteractionID', label: 'Interaction ID' },
    //{ value: 'CaseID', label: 'Case ID' },
  ];

  rowOffset = 0;
  rowCount = 10;
  searchField: any = { label: '', value: '' };
  searchValue: any = '';
  filterDict: any = null;
  sortColumn: string = 'Date'; // Default to Date column for newest-first display
  sortDescend: boolean = true; // Default to descending (newest first)
  filterOptionRequestColumn = null;
  fromDate: Date = new Date();
  toDate: Date = new Date();
  pl: any = {};
  filteredAuditList = new FilteredAuditsList();
  isAuditor: boolean = false;
  cols: any = [
    { name: 'ID', label: 'ID', type: 'numeric' },
    { name: 'Agent', label: 'Agent', showFilter: true },
    { name: 'Type', label: 'Type', showFilter: false },
    { name: 'Group', label: 'Group', showFilter: true },
    { name: 'Manager', label: 'Manager', showFilter: true, format: 'name' },
    { name: 'Auditor', label: 'Auditor', showFilter: true, format: 'name' },
    { name: 'Status', label: 'Status', showFilter: true },
    { name: 'Score', label: 'Score', showFilter: false },
    { name: 'InteractionID', label: 'Interaction ID', showFilter: false },
    { name: 'CaseID', label: 'Case ID', showFilter: false },
    { name: 'SurveyForm', label: 'Survey Form', showFilter: true },
    { name: 'Date', label: 'Date', type: 'date', showFilter: false },
  ];

  ngOnInit(): void {
    const clientAbbreviation = Utils.fetch('clientAbbreviation') || '';
    this.isAuditor = this.securityService.validateGrant('AuditAgents');
    this.isAIAudits = JSON.parse(Utils.fetch('IsAIAudits'));
    if (this.isAIAudits && this.isAuditor) {
      this.router.navigate([clientAbbreviation + '/Console/Auditing/AIAudits']);
    }
    this.fromDate.setMonth(this.fromDate.getMonth() - 6);
   // this.fromDate.setFullYear(this.fromDate.getFullYear() - 1);
    this.pl = {
      rowOffset: 0,
      rowCount: 10,
      filterOptionRequestColumn: this.filterOptionRequestColumn,
      searchValue: this.searchValue,
      searchField: this.searchField.value,
      filterDict: this.filterDict,
      sortColumn: this.sortColumn,
      sortDescend: this.sortDescend,
      currentUserOnly: false,
      isExport: false,
      filter: {
        FromDate: new Date(this.fromDate).getTime(),
        ToDate: new Date(this.toDate).getTime(),
      },
      isAIAudit: false,
    };
    this.appService.currentMenu.subscribe((val: boolean) => {
      this.currentMenu = val;
      this.action = this.currentMenu.name;
    });

    this.searchField = this.findOptions[0];
    this.initializeColumnHeader();
    //this.loadAudits();
  }

  applySelectedDateRange(val) {
    this.toDate = val.toDate;
    this.fromDate = val.fromDate;
    this.loadAudits(null);
  }

  resetDateRange(event: any) 
  {
    this.fromDate = event.fromDate;
    this.toDate = event.toDate;
    this.loadAudits(null);
  }
  // resetDateRange() {
  //   this.toDate = new Date();
  //   this.fromDate = new Date();
  //   this.fromDate.setFullYear(this.fromDate.getFullYear() - 1);
  //   this.loadAudits(null);
  // }
  initializeColumnHeader() {
    const localCol = this.webStorage.getItemFromLocalStorage(this.localStorageName);
    if (localCol != null) {
      this.cols = localCol;
    } else{
      for (const col of this.cols) {
        col.hide = false;
      }
    }
    
    // Always update isAsc property based on current sort state
    for (const col of this.cols) {
      if (col.name == this.sortColumn) {
        if (this.sortDescend) {
          col.isAsc = false;
        } else {
          col.isAsc = true;
        }
      } else {
        delete col.isAsc;
      }
    }
    
    this.webStorage.setItemInLocalStorage(this.localStorageName, this.cols);
    this.getColumnCount();
  }

  getColumnCount() {
    let shown = 0;
    let hidden = 0;
    for (const header of this.cols) {
      if (header.hide) {
        hidden++;
      } else {
        shown++;
      }
    }
    this.headercount.shown = shown;
    this.headercount.hidden = hidden;
  }

  /*globalFilter*/
  clearSearchBox() {
    this.searchValue = '';
    this.pl['searchField'] = { label: '', value: '' };
    this.loadAudits(null);
  }
  clearFilter() {
    this.cols.forEach((col: any) => {
      delete col.filterVals;
    });
    
    // Clear the filter dictionary
    this.filterDict = [];

    this.loadAudits(null);
    // this.auditList = this.applyColumnFilters();
  }

  applyFilterByField(val: any) {
    this.searchField = val.searchField;
    this.searchValue = val.searchValue;
    this.pl.searchField = this.searchField.value;
    this.pl.searchValue = this.searchValue;
    this.loadAudits(null);
  }


  findByMatchingProperties(set: any, properties: any, searchText: string) {
    return set.filter((entry: any) => {
      //alert(typeof(entry[properties.value]))
      if (typeof entry[properties.value] === 'number') {
        if (entry[properties.value].toString() == searchText) {
          return entry;
        }
      } else if (entry[properties.value].toString().includes(searchText)) return entry;
    });
  }
  /*column filter* starts here*/
  toggleCustomColumnFilter(colName: string) {
    this.filterOptionRequestColumn = colName;
    this.loadAudits(null);
  }

  showColumnFilterModal(colName: string) {
    this.cdr.detectChanges();
    this.getColDetails(this.cols, this.filteredAuditList);

    const initialState = {
      cols: this.cols,
      colName: colName,
    };

    const config: ModalOptions = { class: 'task-menu', backdrop: 'static', initialState };
    this.modalRef = this.modalService.show(FilterDialogComponent, config);
    this.modalRef.content.event.subscribe((result: any) => {
      this.cols = result.data;
      this.cdr.detectChanges();
      //this.storeFilteredList(this.cols, colName);
      this.applyColumnFilters();
    });
  }

  storeFilteredList(colData, colName) {
    switch (colName) {
      case 'Agent':
        this.filteredAuditList.agent = colData.filterVals;
        break;
      case 'Group':
        this.filteredAuditList.group = colData.filterVals;
        break;
      case 'Manager':
        this.filteredAuditList.manager = colData.filterVals;
        break;
      case 'Auditor':
        this.filteredAuditList.auditor = colData.filterVals;
        break;
      case 'SurveyFrom':
        this.filteredAuditList.surveyFrom = colData.filterVals;
        break;
      case 'Status':
        this.filteredAuditList.status = colData.filterVals;
        break;
    }
  }

  getFilteredList(colName) {
    switch (colName) {
      case 'Agent':
        return this.filteredAuditList.agent;
      case 'Group':
        return this.filteredAuditList.group;
      case 'Manager':
        return this.filteredAuditList.manager;
      case 'Auditor':
        return this.filteredAuditList.auditor;
      case 'SurveyFrom':
        return this.filteredAuditList.surveyFrom;
      case 'Status':
        return this.filteredAuditList.status;
    }
    return null;
  }

  getColDetails(cols, filteredList) {
    if (filteredList) {
      for (const col of cols) {
        if (col.name == 'Agent') {
          if (filteredList.agent.length > 0) {
            col.filterVals = filteredList.agent;
          }
        }
        if (col.name == 'Group') {
          if (filteredList.group.length > 0) {
            col.filterVals = filteredList.group;
          }
        }
        if (col.name == 'Manager') {
          if (filteredList.manager.length > 0) {
            col.filterVals = filteredList.manager;
          }
        }
        if (col.name == 'Auditor') {
          if (filteredList.auditor.length > 0) {
            col.filterVals = filteredList.auditor;
          }
        }
        if (col.name == 'SurveyFrom') {
          if (filteredList.surveyFrom.length > 0) {
            col.filterVals = filteredList.surveyFrom;
          }
        }
        if (col.name == 'Status') {
          if (filteredList.status.length > 0) {
            col.filterVals = filteredList.status;
          }
        }
      }
    }
  }

  /*column level filter*/
  applyColumnFilters() {
    // Don't clear filterDict - we need to preserve multiple column filters
    // Instead, rebuild it by going through all columns and their current state
    
    this.filterOptionRequestColumn = null;
    
    // Rebuild filterDict based on current column states
    const newFilterDict = [];
    
    for (const colData of this.cols) {
      const filterVals: string[] = [];
      if (colData.filterVals && colData.filterVals.length > 0) {
        for (const val of colData.filterVals) {
          if (val.checked) {
            filterVals.push(val.name.toString());
          }
        }
        // Only add to filterDict if there are actually selected values
        if (filterVals.length > 0) {
          newFilterDict.push({ Key: colData.name, Value: filterVals });
        }
      }
    }
    
    // Replace the entire filterDict with the new one to ensure consistency
    this.filterDict = newFilterDict;
    this.pl.filterDict = this.filterDict;

    this.loadAudits(null);
    
  }

  filterBySelectedFieldValues(set: any, properties: string, searchText: []) {
    if (searchText.length > 0) {
      return set.filter((entry: any) => {
        for (const search of searchText) {
          if (entry[properties].toString() == search) {
            return entry;
          }
        }
      });
    } else {
      return set;
    }
  }

  
  // applyColumnFilters() {
  //   //apply column filter here and assign to dataTodisplay
  //   this.filterDict = [];
  //   // filterDict: [{Key: "Queue", Value: ["Search"]}]
  //   this.filterOptionRequestColumn = null;
  //   for (const colData of this.cols) {
  //     const filterVals: string[] = [];
  //     if (colData.filterVals && colData.filterVals.length > 0) {
  //       for (const val of colData.filterVals) {
  //         if (val.checked) {
  //           filterVals.push(val.name.toString());
  //         }
  //       }
  //       this.filterDict.push({ Key: this.correctFilterColumnName(colData.name), Value: filterVals });
  //     }
  //   }
  //   this.pl.filterDict = this.filterDict;
  //   this.loadAudits(null);
  // }

  showHideColumns() {
    const initialState = {
      headerNames: this.cols,
      localStorageName: this.localStorageName,
    };

    const config: ModalOptions = { class: 'task-menu', backdrop: 'static', initialState };

    this.modalRef = this.modalService.show(ShowHideDialogComponent, config);

    this.modalRef.content.event.subscribe((result: any) => {
      this.initializeColumnHeader();
    });
  }

  
  sortByColumn(colName: string) {
    this.sortColumn = colName;
    this.sortDescend = !this.sortDescend;
// Update column isAsc property for sort icon display
this.first = 0;
for (const col of this.cols) {
  if (col.name == this.sortColumn) {
    col.isAsc = !this.sortDescend;
  } else {
    delete col.isAsc;
  }
}

//this.cols = this.utils.sortByFieldInServer(colName, this.cols);
    // this.webStorage.setItemInLocalStorage(this.localStorageName, this.cols);
    this.loadAudits(null);
  }

  onRowSelect(event: any) {
   // console.log(event);

    const initialState = {
      interactionId: event.data.InteractionID,
    };
    const config: ModalOptions = {
      backdrop: 'static',
      class: 'interactionDetails-Auditmenu',
      initialState,
    };
    this.modalRef = this.modalService.show(InteractionDetailsComponent, config);
    // this.router.navigateByUrl(this.router.url + "/Details/" + event.data.ID)
  }

  loadAudits(event: TableLazyLoadEvent) {
    if(this.isAIAudits && this.isAuditor){
      return;
    }
    this.loading = true;
    if (event == null) {
      this.resetTable();
    } else {
      this.first = event.first;
      this.pl.rowOffset = event.first;
      this.pl.rowCount = event.rows;
    }
    this.loadAuditsTimeout = setTimeout(
      () => {
        //load data of required page
        if (this.filterOptionRequestColumn != null) {
          this.pl.filterOptionRequestColumn =this.filterOptionRequestColumn;
        } /*else {
        this.pl['filterOptionRequestColumn'] = '';
      }*/
        this.auditorService
          .GetAudits(this.pl)
          .pipe(
            map((data: any) => {
              const isValid = ResponseHandler.processResponse(data, 'GetAudits');
              if (isValid) {
                if (this.pl['filterOptionRequestColumn'] != null) {
                  const columnName = this.pl['filterOptionRequestColumn'];
                  this.pl['filterOptionRequestColumn'] = null;

                   // Get existing checked values for this column before resetting
                   const existingCol = this.cols.find(col => col.name === columnName);
                   const existingCheckedValues = existingCol && existingCol.filterVals ? 
                     existingCol.filterVals.filter(val => val.checked).map(val => val.name) : [];

                  const filterVals = [];
                  for (const dt of data.Response.Data) {
                    if (dt != null && dt.trim() != '') {

                       // Preserve the checked state if this value was previously selected
                       const isChecked = existingCheckedValues.includes(dt);
                       filterVals.push({ name: dt, checked: isChecked });
                    }
                  }
                  for (const col of this.cols) {
                    if (col.name == columnName || col.label == columnName) {
                      col.filterVals = filterVals;
                    }
                  }
                  this.showColumnFilterModal(columnName);
                } else {
                  data.Response.Data.Data.forEach(element => {
                  
                    if (element.CaseID == 0) {
                      element.CaseID = '';
                    }
                  });
                  this.auditList = data.Response.Data.Data;
                  if (data.Response.Data.TotalFilteredItems) {
                    this.totalRecords = data.Response.Data.TotalFilteredItems;
                  } else {
                    this.totalRecords = 0;
                  }
                  this.loading = false;
                }
                //trigger change detection
                event.forceUpdate();
                this.setInnerWidthHeightParameters();
              } else {
              }
            }),
            catchError(error => {
              this.loading = false;
              return EMPTY;
            })
          )
          .subscribe();
      },
      Math.random() * 1000 + 250
    );
  }

  resetTable() {
    this.first = 0;
    // this.auditList = [];
    // this.totalRecords = 0;

    this.pl['rowOffset'] = this.rowOffset;
    this.pl['rowCount'] = this.rowCount;
    this.pl['filterDict'] = this.filterDict;
    this.pl['filterOptionRequestColumn'] = this.filterOptionRequestColumn;
    this.pl['filter'] = {
      FromDate: new Date(this.fromDate).getTime(),
      ToDate: new Date(this.toDate).getTime(),
    };
    this.pl['sortDescend'] = this.sortDescend;
    this.pl['sortColumn'] = this.sortColumn;
    this.pl['searchValue'] = this.searchValue;
    this.pl['searchField'] = this.searchField.value;
    // this.pl['sortColumn'] = this.filterDict;
  }
  setInnerWidthHeightParameters() {
    this.innerHeight = window.innerHeight * 0.07;
  }

correctFilterColumnName(colName: string): any {
    let key = colName;
    if(colName == 'SurveyForm'){
      key = 'Survey Form';
    }
    return key;
  }

  ngOnDestroy(): void {
    this.loadAuditsTimeout && clearTimeout(this.loadAuditsTimeout);
  }
}
